export const normalizeAmount = value => {
    const numeric = Number.parseFloat(value ?? 0);
    return Number.isFinite(numeric) ? numeric : 0;
};
